
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/page/[page]",
      function () {
        return require("private-next-pages/components/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/page/[page]"])
      });
    }
  